(function ($, Drupal, window, document) {

  'use strict';

  Drupal.behaviors.insight_articles_promoted = {
    attach: function (context, settings) {

      $(once('slick', '.block-views-blockinsight-articles-block-1 .views-rows')).each(function(_, $el) {
        $($el).slick({
          dots: true,
          infinite: false,
          speed: 300,
          slidesToShow: 3,
          slidesToScroll: 1,
          // centerMode: true,
          // variableWidth: true,
          prevArrow: '<div class="slick-prev"></div>',
          nextArrow: '<div class="slick-next"></div>',
          lazyLoad: 'progressive',
          appendDots: $($el).parent().find('.views-dotsandarrows'),
          appendArrows: $($el).parent().find('.views-dotsandarrows'),
          responsive: [
            {
              breakpoint: 960,
              settings: {
                slidesToShow: 2,
              }
            },
            {
              breakpoint: 640,
              settings: {
                slidesToShow: 1,
              }
            }
          ]
        });
      });

        $(once('slick', '.view-insight-articles.view-display-id-product .views-rows')).each(function(_, $el) {
          $($el).slick({
            // dots: true,
            infinite: false,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 1,
            // centerMode: true,
            // variableWidth: true,
            prevArrow: '<div class="slick-prev"></div>',
            nextArrow: '<div class="slick-next"></div>',
            lazyLoad: 'progressive',
            appendDots: $($el).parent(),
            responsive: [
              {
                breakpoint: 960,
                settings: {
                  slidesToShow: 2,
                }
              },
              {
                breakpoint: 640,
                settings: {
                  slidesToShow: 1,
                }
              }
            ]
          });
        });

      $(once('slick', '.view-insight-articles.view-id-insight_articles .views-rows')).each(function(_, $el) {
        $($el).slick({
          // dots: true,
          infinite: false,
          speed: 300,
          slidesToShow: 3,
          slidesToScroll: 1,
          // centerMode: true,
          // variableWidth: true,
          prevArrow: '<div class="slick-prev"></div>',
          nextArrow: '<div class="slick-next"></div>',
          lazyLoad: 'progressive',
          appendDots: $($el).parent(),
          responsive: [
            {
              breakpoint: 960,
              settings: {
                slidesToShow: 2,
              }
            },
            {
              breakpoint: 640,
              settings: {
                slidesToShow: 1,
              }
            }
          ]
        });
      });

    }
  };

})(jQuery, Drupal, this, this.document);
